import React, { useState } from "react";
import ProgressBar from "../Common/ProgressBar";
import RadioButton from "../../../UI/RadioButton";
const EmploymentStatus = ({
  className,
  slideChange,
  textHeadingLine1,
  textHeadingLine2,
  validation,
  backClick,
  getValues
}) => {
  const [checkedOne, setCheckedOne] = useState("unchecked");
  const [checkedTwo, setCheckedTwo] = useState("unchecked");
  const [checkedThree, setCheckedThree] = useState("unchecked");
  const [checkedFour, setcheckedFour] = useState("unchecked");
  const [checkedFive, setcheckedFive] = useState("unchecked");


  const formData = getValues();

  let yearSelected = formData.YearOfPossession;

  const nextSlide = async (e) => {
    if (e.target.value === "3") {
      setCheckedOne("checked");
      slideChange(e);
    } else {
      setCheckedOne("unchecked");
    }

    if (e.target.value === "4") {
      setCheckedTwo("checked");
      slideChange(e);
    } else {
      setCheckedTwo("unchecked");
    }

    if (e.target.value === "5") {
      setCheckedThree("checked");
      slideChange(e);
    } else {
      setCheckedThree("unchecked");
    }

    if (e.target.value === "6") {
      setcheckedFour("checked");
      slideChange(e);
    } else {
      setcheckedFour("unchecked");
    }

    if (e.target.value === "199") {
      setcheckedFive("checked");
      slideChange(e);
    } else {
      setcheckedFive("unchecked");
    }


  };
  return (
    <>
      <div id="slide-4" className={`${className}`}>
        <ProgressBar value="20" />

        {/* <h3> {textHeadingLine1} </h3> */}
        <h3>
          {" "}
          {`In ${yearSelected}, at the time you secured finance, what was your employment status?`}{" "}
        </h3>
        <div className="radio_buttons">
          <RadioButton
            value="3"
            name="employment"
            className="radio regNextBtn"
            labelName="Employed"
            labelClassName={`radio ${checkedOne}`}
            onClick={nextSlide}
            validation={validation()}
          />

          <RadioButton
            value="199"
            name="employment"
            className="radio-button"
            labelName="Unemployed"
            labelClassName={`radio ${checkedFive}`}
            onClick={nextSlide}
            validation={validation()}
          />
          <RadioButton
            value="4"
            name="employment"
            className="radio regNextBtn"
            labelName="Self-employed"
            labelClassName={`radio ${checkedTwo}`}
            onClick={nextSlide}
            validation={validation()}
          />

          <RadioButton
            value="5"
            name="employment"
            className="radio regNextBtn"
            labelName="Student"
            labelClassName={`radio ${checkedThree}`}
            onClick={nextSlide}
            validation={validation()}
          />

          <RadioButton
            value="6"
            name="employment"
            className="radio regNextBtn"
            labelName="Retired"
            labelClassName={`radio ${checkedFour}`}
            onClick={nextSlide}
            validation={validation()}
          />
        </div>
        <p className="text-center">
          <span
            className="back-btn btn btn-link"
            name="back03"
            children="<< Previous"
            onClick={backClick}
          ></span>
        </p>
      </div>
    </>
  );
};
export default EmploymentStatus;
